module.exports = __webpack_public_path__ + "img/marypop-fg.4670fcfb.png";